import type { EmptyStateProps } from './types';

/**
 * What a list shows before it has anything: a title, why, and the one action that fills it.
 */
export const EmptyState = ({ title, description, action, icon }: EmptyStateProps) => (
  <div className="flex flex-col items-center justify-center gap-2 px-6 py-12 text-center">
    {icon ? <div className="text-gray-300">{icon}</div> : null}
    <p className="text-sm font-medium text-gray-700">{title}</p>
    {description ? <p className="max-w-sm text-sm text-gray-500">{description}</p> : null}
    {action ? <div className="mt-2">{action}</div> : null}
  </div>
);
